var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Auswahl entfernen oder bearbeiten?",
        size: "lg",
        "hide-actions": ""
      },
      on: {
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c(
        "div",
        [
          _vm._v("\n\t\tSoll\n\t\t"),
          _c("Label", {
            staticClass: "font-weight-extra-bold",
            attrs: { characteristic: _vm.characteristic }
          }),
          _vm._v("\n\t\tbearbeitet oder entfernt werden?\n\t")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mt-5 d-flex align-items-center justify-content-end flex-column-reverse flex-md-row"
        },
        [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("hidden")
                }
              }
            },
            [_vm._v("Abbrechen")]
          ),
          _vm._v(" "),
          _c("Button", {
            staticClass: "ml-3 mb-2 mb-md-0",
            attrs: { text: "Entfernen", icon: "bin" },
            on: {
              click: function($event) {
                return _vm.$emit("remove")
              }
            }
          }),
          _vm._v(" "),
          _c("Button", {
            staticClass: "ml-3 mb-2 mb-md-0",
            attrs: { text: "Bearbeiten", icon: "pencil" },
            on: {
              click: function($event) {
                return _vm.$emit("edit")
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }